import React from 'react';

interface FormCardProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * レスポンシブ対応の共通フォームカードコンポーネント
 * 固定幅を排除し、親コンテナの幅に応じて自動調整される
 */
const FormCard: React.FC<FormCardProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`w-full rounded-2xl border border-gray-200 px-6 py-6 mt-5 lg:px-8 ${className}`}
      style={{
        backgroundColor: 'rgba(13, 53, 127, 0.05)',
      }}
    >
      {children}
    </div>
  );
};

export default FormCard;
